import { render, staticRenderFns } from "./TrainingInstitutes.vue?vue&type=template&id=4c3b2652&scoped=true&"
import script from "./TrainingInstitutes.vue?vue&type=script&lang=js&"
export * from "./TrainingInstitutes.vue?vue&type=script&lang=js&"
import style0 from "./TrainingInstitutes.vue?vue&type=style&index=0&id=4c3b2652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3b2652",
  null
  
)

export default component.exports